import * as React from 'react';
import { LoadingName, ProgressWrapper, StyledCircularProgress, Wrapper, } from './LoadingPage.styles';
import ProgressRing from '@weave-design/progress-ring';
import { useConsumeWeaveTheme } from '../../hocs/ApplicationWrapper/theme/WeaveContext';
const getLoadingSize = (size) => {
    if (size === 'md')
        return 60;
    if (size === 'sm')
        return 30;
};
export const LoadingPage = ({ title, size = 'md' }) => {
    const { isWeaveTheme, resolvedRoles } = useConsumeWeaveTheme();
    const sizePx = getLoadingSize(size) || 60;
    return (React.createElement(Wrapper, { size: size },
        isWeaveTheme ? (React.createElement(ProgressRing, { size: size === 'sm' ? 's' : 'm' })) : (React.createElement(ProgressWrapper, { sizePx: sizePx },
            React.createElement(StyledCircularProgress, { size: sizePx }))),
        title && (React.createElement(LoadingName, { isWeaveTheme: isWeaveTheme, resolvedRoles: resolvedRoles }, title))));
};
LoadingPage.defaultProps = {};
export default LoadingPage;
